export default [
  {
    title: 'breadcrumb.agent',
    route: 'list-agent',
    icon: 'UserIcon',
    resource: 'agent',
    action: 'read'
  }
];